import React, { useEffect, useState } from 'react';
import { useCart } from '../context/CartContext';
import { Check } from 'lucide-react';

/**
 * Floating toast that appears in the bottom-right whenever an item is added to
 * the cart. Hooks into CartContext.flash.
 */
const CartToast = () => {
  const { flash } = useCart();
  const [visible, setVisible] = useState(false);
  const [name, setName] = useState('');

  useEffect(() => {
    if (!flash) {
      setVisible(false);
      return;
    }
    setName(flash.name);
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 2200);
    return () => clearTimeout(t);
  }, [flash]);

  return (
    <div
      className={`fixed z-[60] bottom-6 right-6 max-w-sm transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0 pointer-events-none'
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-start gap-3 bg-charcoal-900 text-cream-50 rounded-2xl shadow-elevated px-4 py-3 border border-charcoal-700">
        <span className="shrink-0 mt-0.5 inline-flex items-center justify-center w-6 h-6 rounded-full bg-sage-500 text-white">
          <Check className="w-3.5 h-3.5" strokeWidth={3} />
        </span>
        <div className="min-w-0">
          <div className="text-[14px] font-medium">Added to cart</div>
          <div className="text-[12px] text-cream-200/80 truncate">{name}</div>
        </div>
      </div>
    </div>
  );
};

export default CartToast;
